const parseDate = (value) => {
  if (!value) return null;

  const date = value instanceof Date ? new Date(value) : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const toCalendarTimestamp = (date) =>
  Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());

const toUtcDateOnlyIso = (date) =>
  new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())).toISOString();

export const createAviationRouteDateRows = (order = {}) => [
  {
    id: "loading",
    type: "Loading",
    cityName: order.cityFromName,
    address: order.addressFrom,
    date: parseDate(order.shippingDate),
  },
  {
    id: "unloading",
    type: "Unloading",
    cityName: order.cityToName,
    address: order.addressTo,
    date: parseDate(order.unloadingDate),
  },
];

export const getPreviousFilledDate = (rows, index) => {
  for (let currentIndex = index - 1; currentIndex >= 0; currentIndex -= 1) {
    if (rows[currentIndex]?.date) return rows[currentIndex].date;
  }

  return null;
};

export const validateAviationRouteDates = (rows = []) => {
  const errors = {};

  if (rows[0] && !rows[0].date) {
    errors[rows[0].id] = "required";
  }

  const loadingDate = rows[0]?.date;
  const unloadingDate = rows[1]?.date;

  if (
    loadingDate &&
    unloadingDate &&
    toCalendarTimestamp(unloadingDate) < toCalendarTimestamp(loadingDate)
  ) {
    errors[rows[1].id] = "chronology";
  }

  return errors;
};

export const buildAviationRouteDatesPayload = (orderId, rows) => ({
  orderId,
  shippingDate: rows[0]?.date ? toUtcDateOnlyIso(rows[0].date) : null,
  unloadingDate: rows[1]?.date ? toUtcDateOnlyIso(rows[1].date) : null,
});
